<script>
export default {
  name: 'AppFooter'
}
</script>

<template>
  <div id="AppFooter">
    <div class="greenBar" />
    <img
      alt="ARM logo"
      class="logo img-responsive"
      src="../assets/ARM_Logo_White.svg"
    />
    <div class="version">Version {{ this.$store.state.appVersion }}</div>
  </div>
</template>

<style>
#AppFooter {
  width: 100%;
  height: 112px;
  background-color: #194173;
}
#AppFooter .greenBar {
  height: 6px;
  width: 100%;
  background-color: #00bc70;
}
#AppFooter .logo {
  width: 200px;
  margin-left: 20px;
  margin-top: 25px;
}
#AppFooter .version {
  color: #fff;
  position: relative;
  left: 60px;
  top: -10px;
  text-align: center;
  width: 120px;
}
</style>
